module.exports = __webpack_public_path__ + "static/media/en.e122cfd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/languages/en.svg
// module id = 1691
// module chunks = 0